/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {
    SimpleReelModel,
    SimpleReelModelDelegate,
    SimpleReelModelState,
} from "../../core/reel/simplereel/SimpleReelModel";
import {NineToFive} from "../NineToFive";
import {LayersSet} from "./LayersSet";
import {FreespinMultiplier} from "../components/FreespinMultiplier";
import {NineToFiveSymbol, SymbolArgs} from "./symbols/NineToFiveSymbol";
import {NineToFiveGameAssets} from "../NineToFiveGameAssets";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {gsap} from "gsap";
import {LoopableList} from "../utils/LoopableList";

export class NineToFiveBaseGameReelView extends PIXI.Container implements StageLayer, SimpleReelModelDelegate{

    get reelModels():SimpleReelModel[] {
        return this._reelModels;
    }
    private _reelModels:SimpleReelModel[];
    private _symbolContainer:PIXI.Container;
    public layers:LayersSet;
    public freespinMultiplier:FreespinMultiplier;
    public xBetReel:PIXI.spine.Spine;
    public xNudgeExplosion:PIXI.spine.Spine;
    private xBetDoorTimeline:gsap.core.Timeline;
    private xNudgeExplosionAnimations:LoopableList<string>;

    private symbolWidth:number = 144;
    private symbolHeight:number = 148;
    public static stepDuration:number = 0.04;
    public static reelStopDelay:number =  NineToFiveBaseGameReelView.stepDuration*5;
    public static reelStopDelayFastSpin:number =  NineToFiveBaseGameReelView.stepDuration*2;

    //private static BASE_GAME_REEL_1:string[] = ["XW","L1","L2","L3","L4","M1","M2","M3","M4"];
    //private static DEFAULT_REEL_SET:string[] = ["XW","L1","L2","L3","XN","L4","W","M1","M2","M3","M4", "S"];
    //private static FREE_SPINS_REEL_1:string[] = ["XW", "L1","L2","MN","L3","L4","M1","M2","M3","M4","MP"];
    //private static FREE_SPINS_REEL:string[] = ["XW", "L1","L2","MN","L3","XN","L4","M1","W","OT","M2","M3","M4","MP"];
    private static XBET_REEL_SET:string[] = ["X","X","X","X","X","X","X","S"];

    private static BASE_GAME_REELS:string[][] = [
        [
            "L4","L1","XW","L2","M3","M2","L1","L3","M4","M2","L4","M3","L1","L2","L4","L3","M2","L2","M3","L1",
            "L3","M1","M3","L4","L1","L2","M1","M3","L1","M4","M1","L3","L2","M3","M2","M1","L4","M4","L1","L3",
            "L2","M2","L1","L4","M3","L3","L2","M4","L1","M1","M2","M4","L3","L4","L1","L2","M2","L4","L1","L2",
            "M4","M3","L4","L3","L2","M2","XW","L4","L3","M4","M2","L4","M3","L1","M4","L3","M3","L2","M4","L4",
            "L3","M1","M4","M3","L3","L2","M2","L4","L3","M4","L1","M1","L2","M3","L3","M1","L4","M4","L1","L2",
            "L3","M4","L1","M2","L2","L4","L3","M4","L2","M2","L4","L1","L3","M3","M4","L2","L1","M3","L3","XW",
            "L2","L4","M2","M4","M1","M3","L3","M4","M1","L2","L4","M3","L1","L2","M2","L4","L3","M1","M4","L4",
            "L2","L1","L3","M1","M2","L4","L1","L2","M2","M1","M3","L3","M4","L4","L1","L3","M1","L4","M2","L1",
            "L2","L4","M2","L3","M4","XW","L4","L1","M2","M1","L4","L3","L2","M3","L4","M2","L3","M3","L2","L4",
            "L3","M2","L2","L4","L1","M1","M3","M4","L1","L4","M3","M1","L2","L3","M4","L1","M3","L4","L2","L3",
            "M3","M4","L1","L3","L4","M3","L1","M4","L2","M3","M1","M4","L3","M2","M1","L1","L4","L2","M2","M4",
            "L1","L4","L2","M3","L3","L1","L2","M4","L3"
        ],
        [
            "M1","L2","L3","L4","M4","M3","L1","L3","M2","M4","M3","L4","S","L3","M2","L4","M1","L1","M2","XW",
            "M3","M4","L2","L4","M3","L1","M2","L2","L4","M1","M4","L1","M2","L3","L2","M4","W","L1","L2","M4",
            "L3","L4","M1","M3","L3","L2","M4","M2","L3","L4","M3","M2","L1","L2","M4","M3","L4","S","L1","M3",
            "M4","XW","L3","M1","L1","M3","L2","M2","L4","L1","M3","S","M1","L3","L4","M3","L1","M4","L4","L2",
            "M2","L3","L1","L2","M3","M1","M4","L1","L3","M1","L4","L2","L1","W","M4","L2","L3","L1","M3","L2",
            "M4","M2","L1","M3","L4","L2","M1","L3","L1","M3","L4","M4","L2","L1","M2","M1","L4","XW","M3","M4",
            "L1","L3","M2","L4","L1","L3","M2","L2","M4","M1","L4","L3","L1","L2","M2","L3","M3","M4","M2","L1",
            "L2","M3","M4","S","L3","L2","L4","M2","L3","L2","M1","W","L4","L2","M3","M4","L3","M1","L1","L4",
            "XN","XN","XN","XN","M4","L3","M1","L2","S","L4","M3","L3","M1","M4","L2","L4","M2","L3","M3","L2",
            "L4","M2","XW","L3","L1","M3","L4","M4","L1","L3","L4","L2","M4","L3","L1","M1","M2","L3","L2","M3",
            "M1","L4","L3","L2","L1","M3","L4","L2","M1","M4","L4","L2","M3","XN","XN","XN","XN","L3","L2","L1",
            "L4","L3","M2","L2","M1","L4","M2","L1","L3","L4","M4","L2","L3","L1","L4","M4","W","M2","L3","L4",
            "L1","M4","M3","M2","L1","L4"
        ],
        [
            "L4","M4","L1","L2","M1","L3","M2","L1","M3","M1","M4","M2","L1","L3","M3","L4","L1","L2","M4","L3",
            "L4","L2","L1","M4","M3","L4","M1","L2","L1","L3","M3","L4","M2","M1","L2","L3","L4","M3","L2","L3",
            "L1","M3","M2","M1","L4","M3","L3","S","M4","M2","L1","L3","L4","L2","L1","M2","L4","L3","M4","L2",
            "L4","M3","L1","M1","L2","XW","L4","L1","M1","M4","L3","L1","L4","M3","L3","S","L4","M1","M4","L1",
            "L2","L3","L4","M4","L1","M3","L4","M4","L3","XW","L2","L1","M1","M2","M4","M3","L1","L3","M4","W",
            "M2","L2","M3","L4","L3","L1","L2","M2","S","L4","L3","M2","M3","L1","L3","L4","L2","M4","L3","M3",
            "L2","L1","L4","L3","L2","M3","S","M2","L1","M3","L2","L4","L1","L3","M4","L4","M2","L2","L1","M4",
            "L3","L4","M3","L1","W","L4","M4","L3","M3","M1","XW","M2","L4","M3","L3","L2","M2","L4","M4","M1",
            "M2","L3","L2","M4","L4","M3","L1","L3","L2","M4","L4","M1","L2","L1","M4","L3","M1","L2","W","L4",
            "M4","L2","L1","L3","W","L4","M2","M1","M4","L3","L4","L2","M4","M3","M1","L2","M4","L4","L3","M2",
            "L1","S","M3","M4","L1","XW","L2","M2","M1","M4","XN","XN","XN","XN","M3","L3","L1","M2","L2","L3",
            "M3","M2","L2","L3","L4","M3","L2","M2","L1","L4","M1","M2","XN","XN","XN","XN","M3","L3","L2","L4",
            "L1","M1","L2","M4","M2","M1"
        ],
        [
            "M4","L4","L1","M3","L3","L4","W","L1","M1","L2","M4","M3","L3","L1","L2","L4","M4","L3","M1","L1",
            "L2","L3","M1","M4","M2","L3","S","L4","L1","M2","M1","L4","L2","M3","L1","M4","L3","L4","L1","M2",
            "L2","L4","M1","M3","L3","L1","XW","L2","M4","L4","W","L1","M1","L4","L2","M3","L3","M2","M4","L4",
            "L3","M2","XN","XN","XN","XN","L4","L2","M3","M1","L3","M4","L1","M2","M3","M4","S","L2","L4","M4",
            "L3","XW","M2","M4","L1","M1","L4","L3","M4","L2","M2","L4","M4","L1","M1","M3","L2","L1","L4","M4",
            "L2","L1","M2","L3","L4","L1","M4","L2","M2","L1","L3","M3","M1","L2","XW","M3","L4","M4","L3","L2",
            "L1","M2","L4","M3","L2","L3","L4","M4","M1","M3","L4","L3","M2","W","M3","L3","M2","L2","L4","L3",
            "M4","M3","L1","XW","L3","M2","L4","L2","S","L3","M2","L1","M4","L2","M1","L1","M3","L2","M4","L4",
            "L3","M3","L2","M1","L4","L1","L2","M4","L3","M2","L2","M1","L1","L4","M3","M4","M2","M1","L4","L3",
            "M2","L2","M3","S","L1","L2","M4","L4","L3","M1","L1","M2","L2","M3","M4","S","L2","M3","L1","L4",
            "L3","L2","M3","L4","M1","L1","L2","M4","M2","L3","L4","L1","L2","M3","L3","L1","M2","M4","L4","M3",
            "L3","M2","L4","M3","L1","L3","M1","L4","L1","M2","XN","XN","XN","XN","L3","L4","M3","L2","L3","L1",
            "W","M4","M3","M1","L3","L2"
        ],
        [
            "M3","S","L3","L2","M2","M1","M4","L2","W","L4","L1","L3","M4","L2","M2","L3","M1","L1","M2","L2",
            "L3","M4","L1","L2","M3","M1","L4","L3","M2","L2","L4","M4","L3","M3","L4","M2","L3","M1","M3","L4",
            "L2","L3","L1","M4","L4","L3","L2","M4","M2","XW","L3","L2","M2","M1","S","L2","L1","L3","L4","XN",
            "XN","XN","XN","L1","M3","L2","M4","L3","L4","M1","L2","L1","M2","M4","L4","L3","M2","L1","L2","M3",
            "L4","L1","M2","L3","L2","M3","M1","L4","L2","L1","M1","M4","M3","L4","XN","XN","XN","XN","L2","M3",
            "L3","L1","L4","M4","XW","L1","M2","L2","L3","L1","M3","XW","M4","L4","L3","L2","L1","L4","M2","M1",
            "L2","M4","L4","M2","M1","M4","L4","L2","L3","L1","L4","M2","S","M3","L4","L1","M4","L3","L2","L4",
            "M3","M1","L1","L4","M2","M4","L1","M3","L3","W","M4","L1","L4","M3","M1","L2","M4","L4","L3","M3",
            "M4","L2","L4","M1","M2","L1","L3","L4","M1","M4","M3","L1","L2","M4","L3","M2","XW","M4","L2","L4",
            "M3","L3","L1","M4","L2","L3","M2","M3","L2","L1","L4","M2","L3","L1","M3","L2","L3","L4","M3","L1",
            "M4","S","M2","L3","L4","S","M3","M1","L1","L4","L2","M3","M4","L4","M1","L3","M3","L1","L2","L3",
            "W","M2","L2","M3","L1","W","L3","M4","M3","L2","L3","L1","L4","M1","M2","M3","L3","L1","M1","M4",
            "M2","L4","L1","M1","M4","L4"
        ]
    ];

    private static FREESPINS_REELS:string[][] = [
        [
            "L2","L1","M4","M3","L3","M2","L4","M4","L1","M2","L3","M1","M3","L4","L2","M4","M3","L3","L4","M1",
            "M4","L2","L3","M3","M1","L4","L2","L3","L1","M4","L4","L3","M3","L1","M1","L3","M2","L4","M4","XW",
            "L2","L3","L1","M3","L2","L3","L4","M3","XW","L2","L4","M2","M3","M4","L1","L4","M1","L3","M2","L4",
            "M1","L1","M4","M3","L2","M2","L4","L1","M4","M3","L2","L1","XW","L4","L2","L1","M2","M3","L2","L4",
            "L3","MP","L1","L4","L3","L2","M4","MN","L3","M2","L1","L4","MN","M4","L2","L3","L1","M3","M4","L3",
            "M1","M2","L2","L3","L4","L1","M3","L3","L2","M2","M3","MN","L4","L1","L3","M1","L2","MN","M4","M2",
            "L2","L4","L1","M2","L2","L3","M1","L4","L2","XW","L1","L3","M4","L4","L1","L3","M3","L2","M4","M1",
            "L4","M2","M3","L2","L4","L1","M1","L3","M4","L1","M2","L3","M4","L1","L4","L2","M1","M3","L3","L2",
            "M1","L4","L3","M3","L2","L1","L4","M4","L2","L3","M1","M2","M3","MN","L4","L2","M4","M1","L4","L3",
            "L1","M2","M3","L2","L1","L4","M1","MP","L1","M2","L4","M4","L2","L3","M2","L4","L2","L1","M4","M3",
            "MP","M2","L3","M4","L1","MP","M3","L2","M1","L4","L1","L3","M4","M2","L4","MP","M4","M3","L1","L2",
            "M2","L3","M4","L1","M2","L3","L4","M4","M1","M2","M3","L2","MP","L1","L4","M3","M4","M1","L3","M3"
        ],
        [
            "MP","L1","M1","L3","M2","L4","M3","M4","L1","L3","L2","M3","L1","M4","M2","L2","L3","L1","M3","MP",
            "L4","L3","M2","L2","W","L1","M4","L2","L4","L3","M2","L2","L1","W","L4","M1","M4","L3","L4","M1",
            "L2","M2","M3","L1","L2","XW","M2","M3","L4","L3","XW","L2","L1","L4","M2","L3","L1","M1","L2","M4",
            "L3","M1","M3","L2","M2","MN","L3","M4","M1","L4","L2","M3","M1","L4","L3","OT","MN","L1","L2","M4",
            "XN","XN","XN","XN","L4","L1","M3","L3","M1","M2","M3","L1","L2","M2","L3","L1","M4","L2","M1","L3",
            "M4","L1","M3","M2","MN","L4","OT","L1","L2","L4","M3","L1","MP","M4","L2","M1","M2","L3","L2","M3",
            "L4","L1","OT","M2","L3","M4","M3","L4","L1","L3","MP","M3","M4","L4","L1","W","M2","L4","L2","M1",
            "L3","L1","L2","M4","L4","M2","L3","M4","L1","M2","L4","M4","M3","L3","L4","L1","M4","L3","M3","L4",
            "W","L2","L3","M1","M4","L4","L3","L2","M1","M3","L4","L2","M4","M3","L4","MP","OT","L1","M2","L4",
            "L2","L3","M2","L1","M3","L4","L2","L3","M3","M4","MN","L4","M3","L1","M1","L2","M2","L3","L4","M4",
            "L1","L2","L4","M4","M2","L1","M3","L2","L3","MP","M4","M2","L2","L4","L3","L1","MN","M4","M3","L2",
            "L4","L3","M4","M1","L1","M2","XW","L3","L2","M1","L4","L1","L3","L2","M4","M1","M3","L2","XW","L1",
            "M1","L4","L3","OT","M3","L4","M4","M1","L3","XN","XN","XN","XN","M2","M3","L4","M4"
        ],
        [
            "M3","M1","MN","M2","L1","L4","M1","L3","L1","M4","M1","M2","L3","L4","MP","L2","L1","M4","L3","L2",
            "L1","MN","M1","L4","M2","M3","XN","XN","XN","XN","L4","L2","L3","MN","M4","M2","L3","M3","M4","M1",
            "M2","L1","XW","M3","L2","L4","L1","M3","W","L3","L1","M4","L4","MN","M3","L2","L3","MP","L1","OT",
            "L2","M1","L3","L4","M3","L1","L3","XW","M2","L4","M4","L3","L2","MP","M4","M1","L3","L2","M3","M1",
            "M4","XN","XN","XN","XN","L4","L2","L3","M3","M2","L1","L4","M3","L2","W","M4","M2","L3","L2","M1",
            "M4","L1","M2","L4","L2","M4","L3","M2","L4","L1","M4","L2","L3","M3","L4","M1","L1","M3","M4","L4",
            "M2","L1","L2","L4","M3","L3","M1","L1","M4","L2","M1","L4","M4","L3","M3","M1","MP","L3","M3","M4",
            "M1","L1","XW","L3","L4","M1","M2","L2","L3","L1","OT","L4","L2","L1","L3","M4","M3","M1","M2","L4",
            "L3","XW","M3","OT","L2","L1","M4","L4","M2","L2","M4","L4","L1","M3","M2","M1","L1","L3","L2","M2",
            "M4","L4","M3","MP","L2","L3","OT","L4","M2","L2","MN","L1","L4","L2","M3","M4","MP","L2","L1","M1",
            "L3","L2","M3","L4","L1","M4","L3","M3","L2","L1","M4","M2","L3","L4","L1","M4","M3","L4","L2","L1",
            "W","M4","L4","M2","L2","L1","L4","W","L3","M3","L1","L2","L3","OT","L4","L2","L3","M1","M4","M2",
            "L3","M3","L4","M4","L2","M2","L4","M3","L1","L3","M2","L4","L2","L1","L3","M2","L4"
        ],
        [
            "L2","M1","M2","L4","L3","L2","M4","MN","L4","M1","L3","M3","L2","L1","M1","L3","M2","L4","W","L2",
            "M3","L1","M4","MP","M1","L2","L4","XN","XN","XN","XN","M2","L3","L1","L4","M2","M4","L2","M3","M2",
            "L3","L4","L2","M4","M1","L1","L3","XW","M2","L1","M1","M3","L3","L2","L1","M2","L3","MP","M3","L4",
            "M4","L3","W","L4","L2","L1","M3","M2","L2","L3","OT","M2","L4","L2","M3","M2","OT","XN","XN","XN",
            "XN","M4","M3","OT","L4","L2","L1","M2","XW","L4","M4","M3","L1","L2","M4","M1","MP","L3","L1","L2",
            "M1","MP","L1","M3","L4","M2","L2","L3","L1","M4","L2","M1","L4","M4","W","L3","L1","OT","M4","L2",
            "L4","L1","MP","M4","M2","L3","L2","L1","M3","M1","M4","L3","L1","W","L4","M4","L1","L2","L4","L3",
            "M4","M1","L2","M2","L4","L1","L3","M4","L4","M1","L1","M2","L2","L4","M3","L3","M1","L1","L2","M3",
            "L4","M2","L1","M3","MN","M4","L3","M1","L4","M2","M4","L1","L3","M3","M1","L4","L3","M4","L2","L1",
            "L3","M3","M4","L4","L2","M2","L3","MN","M1","M3","L3","L2","L4","L1","L3","M3","L2","L1","L4","L3",
            "M2","MN","M3","L2","M4","L4","L1","M3","L3","M4","XW","M2","OT","M3","XW","L4","L3","M1","L1","L4",
            "M3","M4","L3","L2","L4","MN","M4","L2","L3","L4","L1","M3","L3","M1","M4","L2","L4","M3","L1","M2",
            "L4","L3","L2","M2","MP","L4","M4","M3","M1","L2","L1","L3","L4","M2","M4","L1","M3"
        ],
        [
            "M3","L3","M2","L4","MN","M4","L2","L1","L4","M2","M4","M1","L2","L3","L1","M3","M4","L3","L2","M3",
            "L4","L1","M2","L3","L4","M1","L2","L1","M4","XN","XN","XN","XN","L2","L1","L4","M1","L2","L3","M3",
            "M4","MP","L2","M1","L3","M4","L1","M3","L2","M4","L3","M2","L4","M3","M4","L3","MN","M2","M1","L2",
            "L1","M3","L4","M2","W","L2","L3","M3","L1","L4","M4","M2","L3","M1","L4","L1","L3","M4","OT","XW",
            "L2","L3","L1","M4","L4","M1","L3","M2","MP","L1","L2","M1","L3","L4","M3","L1","L2","M2","M3","L4",
            "L1","M4","M3","XW","L4","M4","L1","MP","L2","M2","L4","MN","L1","M4","M2","L4","L1","L2","M3","M1",
            "L4","W","L2","L3","M4","M3","L4","L3","L2","M1","L1","M3","M2","M4","L3","L2","L1","M2","L4","MP",
            "M3","L1","M1","L4","L3","L2","M4","M2","L4","M1","M3","MN","M2","L1","M3","L3","M4","L1","M3","L3",
            "L4","M1","L2","L1","L4","L3","XN","XN","XN","XN","L2","L4","L3","M3","L1","M2","M1","M4","L2","L4",
            "M3","MP","L1","L3","L4","M4","M3","L2","M2","L1","XW","M4","L4","L3","XW","M2","L2","L1","W","L3",
            "OT","L4","M3","L3","L1","L2","M1","M3","L4","L2","MN","M2","L3","L2","MP","L4","M2","L2","M4","L1",
            "M1","OT","L3","W","M3","L2","M4","L1","L4","L2","L3","M1","M3","M2","L1","L2","M4","L4","OT","M2",
            "L3","M4","M3","L4","L3","M4","OT","L1","M1","L4","L3","L2","M4","M2","L3","M1","L4"
        ]
    ];

    constructor() {
        super();
        this.name = "NineToFiveBaseGameReelView";
        this.layers = new LayersSet();

        this.init();
    }

    private init() {

        //this.layers.maskedNormal = new PIXI.Container();
        //this._symbolContainer.position.set(0, 164);
        this.xBetDoorTimeline = gsap.timeline();

        this.layers.maskedNormal.y = 164;
        this.addChild(this.layers.maskedNormal);
        this.layers.maskedM1.y = 164;
        this.addChild(this.layers.maskedM1);
        this.layers.maskedScatters.y = 164;
        this.addChild(this.layers.maskedScatters);
        this.layers.maskedOver.y = 164;
        this.addChild(this.layers.maskedOver);
        this.layers.win.y = 164;
        this.addChild(this.layers.maskedWinCap);
        this.layers.maskedWinCap.y = 164;
        this.addChild(this.layers.win);

        const symbolMask = new PIXI.Graphics();
        symbolMask.beginFill();
        symbolMask.drawRect(0,-74,this.symbolWidth* 5, this.symbolHeight * 4);
        this.layers.maskedNormal.addChild(symbolMask);
        this.layers.maskedNormal.mask = symbolMask;
        this.layers.maskedM1.addChild(symbolMask);
        this.layers.maskedM1.mask = symbolMask;
        this.layers.maskedScatters.addChild(symbolMask);
        this.layers.maskedScatters.mask = symbolMask;
        this.layers.maskedOver.addChild(symbolMask);
        this.layers.maskedOver.mask = symbolMask;
        this.layers.maskedWinCap.addChild(symbolMask);
        this.layers.maskedWinCap.mask = symbolMask;

        // TODO move filename to game assets file
        this.xBetReel = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.XBET_DOOR));
        this.xBetReel.position.set(648, 384);
        //this.xBetReel.visible = false;
        this.addChild(this.xBetReel)
        this.xNudgeExplosionAnimations = new LoopableList([
            "X_Nudge_FX_1",
            "X_Nudge_FX_2",
            "X_Nudge_FX_3",
            "X_Nudge_FX_4",
            "X_Nudge_FX_5",
            "X_Nudge_FX_6",
        ]);

        this.xNudgeExplosion = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.XNUDGE_EXPLOSION));
        //this.xNudgeExplosion.visible = false;
        //this.xNudgeExplosion.state.setAnimation(0, "X_Nudge_FX_1", true);
        this.addChild(this.xNudgeExplosion);

        this.freespinMultiplier = new FreespinMultiplier();
        this.freespinMultiplier.position.set(510, 50);
        this.freespinMultiplier.visible = false;
        this.addChild(this.freespinMultiplier)

        //this.addChild(this._symbolContainer);

        this._reelModels = [];
        for (let i:number = 0; i < 5; i++){
            const reel = new SimpleReelModel(i, this, true);
            //reel.setReelSet(i == 0
            //                ? NineToFiveBaseGameReelView.BASE_GAME_REEL_1
            //                : NineToFiveBaseGameReelView.DEFAULT_REEL_SET);
            reel.setReelSet(NineToFiveBaseGameReelView.BASE_GAME_REELS[i]);
            reel.stepDuration = NineToFiveBaseGameReelView.stepDuration;
            reel.stepSize = this.symbolHeight;
            reel.init(NineToFive.model.data.reels[i].concat());

            //reel.events?.on(SimpleReelModelState.BOUNCE, (data:SimpleReelModelEventData)=>{
            //    //Switches state of all symbols from spin state to normal, when the symbols bounce.
            //    for (let symbolData of reel.stopSymbols) {
            //        (<TheCageSymbol>symbolData.positionable).setState(TheCageSymbolStates.NORMAL);
            //    }
            //});
            //reel.events?.on(SimpleReelModelState.SPIN, (data:SimpleReelModelEventData)=>{
            //    //Switches state of all symbols from whatever state to spin when reel wind up is done and the spinning starts.
            //    for (let symbolData of reel.stopSymbols) {
            //        (<BlankSlotSymbol>symbolData.positionable).setState(TheCageSymbolStates.SPIN);
            //    }
            //});

            this._reelModels.push(reel);
        }

    }

    public playXNudgeExplosion(reel:number, fromTop:boolean):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.xNudgeExplosion.position.x = 72 + this.symbolWidth * reel;
                this.xNudgeExplosion.position.y = fromTop ? 382 : 390;
                this.xNudgeExplosion.scale.y = fromTop ? -1 : 1;
                //this.xNudgeExplosion.visible = true;
            })
            //.add(SpineGSAPWrapper.createTimeline(this.xNudgeExplosion,
            //                                     0,
            //                                     `X_Nudge_FX_${Math.floor(Math.random() * 6 + 1)}`))
            .add(SpineGSAPWrapper.createTimeline(this.xNudgeExplosion,
                                                 0,
                                                 this.xNudgeExplosionAnimations.next()))
            .add(() => {
                this.xNudgeExplosion.state.setEmptyAnimation(0, 0);
               //this.xNudgeExplosion.visible = false;
            });
    }

    public enableXBetReel(clicked: boolean = false):void {
        if (clicked) {
            this.xBetDoorTimeline.progress(1, false);
            this.xBetDoorTimeline = gsap.timeline()
                .add(() => {
                    //this.xBetReel.visible = true;
                    this.xBetReel.state.setEmptyAnimation(0,0);
                    this._reelModels[4].setReelSet(NineToFiveBaseGameReelView.XBET_REEL_SET);
                })
                .add(SpineGSAPWrapper.createTimeline(this.xBetReel, 0, "In"))
                .add(() => {
                    this.xBetReel.state.setAnimation(0, "Active", true);
                });
        } else {
            this.xBetReel.state.setEmptyAnimation(0,0);
            //this.xBetReel.visible = true;
            this._reelModels[4].setReelSet(NineToFiveBaseGameReelView.XBET_REEL_SET);
            this.xBetReel.state.setAnimation(0, "Active", true);
        }
    }

    public disableXBetReel(clicked: boolean = false):void {
        if (clicked) {
            this.xBetDoorTimeline.progress(1, false);
            this.xBetDoorTimeline = gsap.timeline()
                .add(SpineGSAPWrapper.createTimeline(this.xBetReel, 0, "Out"))
                .add(() => {
                    //this.xBetReel.visible = false;
                    this.xBetReel.state.setAnimation(0, "Inactive", true);
                    this.xBetReel.state.setEmptyAnimation(0,0);
                    this._reelModels[4].setReelSet(NineToFiveBaseGameReelView.BASE_GAME_REELS[4]);
                });
        } else {
            //this.xBetReel.visible = false;
            this.xBetReel.state.setAnimation(0, "Inactive", true);
            this.xBetReel.state.setEmptyAnimation(0,0);
            this._reelModels[4].setReelSet(NineToFiveBaseGameReelView.BASE_GAME_REELS[4]);
        }

    }

    public setBaseReelSet():void {
        this._reelModels.forEach((reel, index) => {
            //reel.setReelSet(index == 0
            //                ? NineToFiveBaseGameReelView.BASE_GAME_REEL_1
            //                : NineToFiveBaseGameReelView.DEFAULT_REEL_SET);
            reel.setReelSet(NineToFiveBaseGameReelView.BASE_GAME_REELS[index]);
        })
    }

    public setFreeSpinsReelSet():void {
        this._reelModels.forEach((reel, index) => {
            //reel.setReelSet(index == 0
            //                ? NineToFiveBaseGameReelView.FREE_SPINS_REEL_1
            //                : NineToFiveBaseGameReelView.FREE_SPINS_REEL);
            reel.setReelSet(NineToFiveBaseGameReelView.FREESPINS_REELS[index]);
        })
    }

    createSymbol(symbolName:string, state:SimpleReelModelState, reelID:number, position:number):NineToFiveSymbol {
        const symbolArgs:SymbolArgs = {
            symbolName: symbolName,
            isSpinning: state == SimpleReelModelState.SPIN,
            isStopping: state == SimpleReelModelState.STOP,
            reelsView: this,
            reelPosition: position,
            reelID: reelID,
            symbolSize: NineToFive.model.data.symbolSizes != undefined
                        //? TheCage.model.data.symbolSizes[reelID][position + 1]
                        ? NineToFive.model.data.symbolSizes[reelID][position + (position == -1 && symbolName == "XN" ? 1 : 0)]
                        : 1,
            bigSymbolData:NineToFive.model.bigSymbolData[reelID],
            xNudgeSize: NineToFive.model.data.xNudgeMultipliers[reelID] / NineToFive.model.data.xNudgeMultipliers[reelID-1]
        };

        const symbol = NineToFive.symbolFactory.createSymbol(symbolArgs);
        symbol.position.x = reelID * this.symbolWidth + this.symbolWidth*0.5;
        return symbol;
    }

    removeSymbol(symbolData:NineToFiveSymbol):void {
        symbolData.destroy();
    }

    getAllSymbols():NineToFiveSymbol[] {
        return <NineToFiveSymbol[]>this._reelModels
            .map((reel) => reel.getAllVisibleSymbols())
            .reduce((a,b) => a.concat(b), []);
    }

    getAllSymbolsActually():NineToFiveSymbol[] {
        return <NineToFiveSymbol[]>this._reelModels
            .map((reel) => reel.getAllSymbols())
            .reduce((a,b) => a.concat(b), []);
    }

    getVisibleSymbolAt(column:number, row:number) {
        const visibleSymbols = this._reelModels[column].getAllVisibleSymbols();
        // @ts-ignore
        return visibleSymbols[row];
    }
}